import { FORM_ID } from "../../../../../constants/Forms";
import ReviewSignSectionHeader from "./ReviewSignSectionHeader";

function ReviewResAddress(props) {
  let resAddress = getResAddress(props.residentialAddress);

  const toggleForm = () => {
    props.toggleForm(FORM_ID.RESIDENTIAL_ADDRESS);
  };
  return (
    <div id="residential-address">
      <ReviewSignSectionHeader
        toggleForm={toggleForm}
        id={"ra"}
        headerText="Residential Address"
      ></ReviewSignSectionHeader>
      <div className="row">
        <div className="col-lg-3 col-md-3 col-sm-12" id="add">
          <h5 id="adrs">Address</h5>
        </div>

        <div
          id="residential_address"
          className="col-lg-9 col-md-9 col-sm-12 data"
        >
          {resAddress}
        </div>
      </div>
    </div>
  );
}

function getResAddress(residentialAddress) {
  let resAddress = "";
  const { address1, address2, city, state, zip, resurbanization } =
    residentialAddress;
  const isThereUrbanization =
    resurbanization !== undefined &&
    resurbanization !== "" &&
    resurbanization !== null;
  resAddress = `
    ${state === "PR" && isThereUrbanization ? `${resurbanization}, ` : ""}
    ${address1}, ${
      address2 === "" ? "" : `${address2}, `
    }${city}, ${state}, ${zip}`;

  return resAddress;
}

export default ReviewResAddress;
